import React from 'react';
import ReactPlayer from 'react-player'


class LocalVideoPlayer extends React.Component {
  render() {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', width: '100vw'}}>
        <ReactPlayer 
            url='https://www.youtube.com/playlist?list=PLaM_JrcU2mC5bVSKs0tGIFGKnN66Bnom0' 
            width='100%'
            height='100%'
            muted={true}
            playing={true}
            controls={true}
            autoPlay
        />
      </div>
    );
  }
}

export default LocalVideoPlayer;
